import { isVpcMode } from "@/utils/vpcMode";

// Limit attribution to the partner signup entry point. Return and login URLs
// only need the destination once the backend has recorded the new account.
export function isFrankaSignup(location: Pick<Location, "pathname" | "search">): boolean {
  return !isVpcMode() && /^\/signup\/?$/.test(location.pathname) &&
    new URLSearchParams(location.search).get("partner") === "franka-labs";
}
